import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export interface LongRunningProcessListGridActionCellRendererParams extends ICellRendererParams {
    updateError: (params: LongRunningProcessListGridActionCellRendererParams) => void;
    canUpdateError: (params: LongRunningProcessListGridActionCellRendererParams) => boolean;
}

@Component({
    selector: 'lrp-list-grid-action-cell',
    template:
        `@if (params && params.data && params.canUpdateError(params)) {
  <button type="button"
    class="ace-btn btn-primary btn-danger has-icon grid-action-button"
    (click)="params.updateError(params)"
    helpTooltip
    helpContentId="long-running-process-list.update-error"
    position="bottom">
    <i class="fa fa-stop"></i>
  </button>
}`,
    standalone: false
})
export class LongRunningProcessListGridActionCellRendererComponent implements ICellRendererAngularComp {
    params: LongRunningProcessListGridActionCellRendererParams;

    agInit(params: LongRunningProcessListGridActionCellRendererParams): void {
        this.params = params;
    }

    refresh(): boolean {
        return false; // tells grid to handle refreshing
    }
}
